
import './jquery';
import './easing';
import './simple-dd';
//import './magnific';
//import './slick';
import './tooltipster';
//import './select2';
import twire from './twire';




'use strict';


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $main 			= $('main');
var $footer 		= $('footer');
var $mobileMenu		= $('div.mobile-menu');



/**
 * Run TWire functions
 */
twire.init();


/**
 * Remove class
 */
$('html').removeClass('no-js'); 


/**
 * Populate mobile menu; must be done before simpleDD
 */
$mobileMenu.find('div.inner div.logo')
           .html($header.find('div.main div.logo').html());

$mobileMenu.find('div.inner nav')
           .html($header.find('div.sub nav').html());

$mobileMenu.find('div.inner div.contact')
           .html($header.find('div.main div.contact').html());

$mobileMenu.find('div.inner div.social')
           .html($header.find('div.main div.social').html());


/**
 * Mobile open
 */
$header.find('a.menu')
       .on('click', function(e) {

	e.preventDefault();

	$mobileMenu.addClass('active');

});


/**
 * Mobile close
 */
$mobileMenu.find('a.close')
           .on('click', function(e) {

	e.preventDefault();

	$mobileMenu.removeClass('active');

});


/**
 * Drop down
 */
$header.find('span.drop-down')
       .simpleDD({

	dropdownElement: 'span.child',
	noScriptLink:    '> a'

});


/**
 * Panels
 */
$('div.faqs').on('click', 'a.toggle', function(e) {
	
	e.preventDefault();
	
	var $this = $(this);
	
	$this.closest('div.faq')
	     .toggleClass('active');
	
});


/**
 * Generic lightboxes
 */
// 3. Magnific Popup Loader
const $lightboxes = $('a.lightbox.video, a.lightbox.inline, div.gallery');

if ($lightboxes.length > 0) {
	
	try {

		await import('./magnific');

		// Video Lightbox
		$('a.lightbox.video').magnificPopup({

			disableOn: 900,
			type: 'iframe',
			mainClass: 'lightbox-effect',

		});

		// Inline Lightbox
		$('a.lightbox.inline').magnificPopup({

			type: 'inline',
			mainClass: 'lightbox-effect',

		});

		// Gallery
		$('div.gallery').magnificPopup({

			delegate: 'a',
			type: 'image',
			mainClass: 'lightbox-effect',
			gallery: {

				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1]

			}

		});

	} catch (err) {

		console.error("Magnific Popup failed to load:", err);

	}

}


/**
 * Slick — uses data attribute for config
 */
const $slickElements = $('div[data-slick]');

if ($slickElements.length > 0) {

	await import('./slick');

	$slickElements.slick();

}


/**
 * Tooltips
 */
$('.tooltip').tooltipster({

	trigger: 'click'

});


/**
 * Map
 */
var $mapInner = $('div.region-map-inner');

$('div.region-map a.region-marker').on('mouseenter mouseleave', function(e) {

    e.preventDefault();

    if (e.type == 'mouseenter') {

        $mapInner.addClass($(this).data('area'));

    } else {

        $mapInner.attr('class', 'region-map-inner');

    }

});


/*
 * Banner select
*/
var bannerSelect	= [];
var $banner 		= $main.find('div.banner');
var $mainLinks 		= $banner.find('nav.siblings.main a');

if ($mainLinks.length > 0) {

	if ($mainLinks.length > 0) {

		$mainLinks.each(function() {

			var $a = $(this);

			var obj = {

				url: 		$a.attr('href'),
				title: 		$a.text(),
				active: 	$a.hasClass('active'),
				children:	[]

			};

			if ($a.hasClass('active') === true) {

				var $children = $banner.find('nav.siblings.sub a:not(.heading)');

				var children = [];

				if ($children.length > 0) {

					$children.each(function() {

						var $c = $(this);

						children.push({

							url: 		$c.attr('href'),
							title: 		$c.text(),
							active: 	$c.hasClass('active')

						});
						
					});

				}

				obj.children = children;

			}

			bannerSelect.push(obj);

		});

	}

	var $select = $main.find('div.banner-select select');

	$.each(bannerSelect, function() {

		var obj = this;

		$select.append($('<option>', {

			value: obj.url,
			text: obj.title

		}));

		if (obj.children.length > 0) {

			$.each(obj.children, function() {

				var obj2 = this;

				$select.append($('<option>', {

					value: obj2.url,
					text: obj.title + ' » ' + obj2.title

				}));

			});

		}

	});

	$select.val(location.pathname);

	$select.on('change', function() {

		window.location = $(this).val();

	});

} else {

	$main.find('div.banner-select')
	     .remove();

}


/**
 * Select2
 */
const $selects = $('select');

if ($selects.length > 0) {

	await import('./select2');

	$selects.select2({

		width: '100%',
		minimumResultsForSearch: -1

	});

}


/**
 * Tabbed content
 */
$('div.tabbed-content').each(function() {

	var $this = $(this);

	var $tabs 	= $this.find('a.tab');
	var $panels	= $this.find('div.panel');

	$panels.addClass('inactive');

	$tabs.on('click', function(e) {

		var $tab = $(this);

		e.preventDefault();

		$tabs.removeClass('active');
		$panels.addClass('inactive');

		$tab.addClass('active');

		var el = '.' + $tab.data('tab');

		$panels.filter(el)
		       .removeClass('inactive');

		$this.find('div.select select')
		     .val($tab.data('tab'))
			 .select2(select2Config); // Can't use trigger'change') as it causes an infinite loop so reinit select2 imstead

	});

	$tabs.eq(0)
	     .trigger('click');

});


/**
 * Tabbed content select
 */
$main.find('div.tabbed-content div.select select')
     .on('change', function(e) {

	var $this = $(this);

	$this.closest('div.tabbed-content')
	     .find('a.tab.button[data-tab="' + $this.val() + '"]')
		 .trigger('click');

	e.stopImmediatePropagation();

});


/**
 * Mobile menu effect
 */
$window.on('scroll resize', function() {

    if ($window.scrollTop() > 30) {

        $header.addClass('alt');

    } else {

        $header.removeClass('alt');

    }

});

/**
 * Site messages
 */
$('div.site-message').each(function() {

	var $this = $(this);

	var icon = 'check';

	if ($this.hasClass('warning') === true) {

		var icon = 'exclamation-circle';

	} else if ($this.hasClass('notice') === true) {

		var icon = 'info-circle';

	} else if ($this.hasClass('error') === true) {

		var icon = 'frown-o';

	}

	$this.append('<a class="fa fa-remove close"></a>')
	     .prepend('<span class="fa fa-' + twire.util.html(icon) + '"></span> ')
	     .find('a.close')
		 .on('click', function(e) {

		$(this).closest('div.site-message')
		       .remove();

	});
	
	if ($this.hasClass('unclosable') === true) {
		
		$this.find('a.close').remove();
		
	}

});


/**
 * Product reveal
 */
$main.find('section.product-reveal-section')
     .addClass('inactive');

$main.find('section.product-reveal a.button')
     .one('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$main.find('section.product-reveal-section')
	     .removeClass('inactive');

	$this.remove();

});


$window.trigger('resize');
$window.trigger('scroll');